<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate('translations') | capitalize }} - {{ language }}</h1>
      <b-field grouped>
        <b-field horizontal :label="$translate('translateTo') | capitalize">
          <b-select v-model="selectedToLanguage">
            <option v-for="language in fromLanguages" :key="language.name">
              {{ language.name }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal :label="$translate('module') | capitalize">
          <b-select v-model="selectedModule">
            <option v-for="(materialTypes, moduleName) in $availableMaterials" :key="moduleName" :value="moduleName">
              {{ $translate(moduleName) | capitalize }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal :label="$translate('section') | capitalize">
          <b-select v-model="selectedSection">
            <option v-for="section in $availableMaterials[selectedModule]" :key="section" :value="section">
              {{ $translate(section) | capitalize }}
            </option>
          </b-select>
        </b-field>
      </b-field>
      <template v-if="selectedSection">
        <h1 class="is-size-3">
          {{ $translate(selectedSection) | capitalize }}
        </h1>
        <template v-for="string_key in tablematerial[selectedSection]">
          <b-field :key="string_key.commercial_name" :label="string_key.commercial_name" horizontal grouped>
            <template v-if="string_key.translations">
              <b-input
                v-model="string_key.translations[selectedToLanguage]"
                @input="checkSingleDisabledSaving(string_key)"
              />
              <p class="control">
                <b-button
                  :disabled="disabledSaving[string_key.id]"
                  class="button is-primary"
                  @click="saveTraslation(string_key)"
                >
                  <b-icon icon="content-save-outline" />
                </b-button>
              </p>
            </template>
            <template v-else>
              <b-button class="button is-primary" @click="addTranslation(string_key)">
                <b-icon icon="plus" />
              </b-button>
            </template>
          </b-field>
          <hr :key="string_key.id + 'hr1'" />
          <b-field
            v-for="string_key_variant in string_key.variants"
            :key="string_key_variant.id + string_key.id"
            horizontal
            :label="string_key_variant.name"
          >
            <template v-if="string_key_variant.translations">
              <b-input
                v-model="string_key_variant.translations[selectedToLanguage]"
                @input="checkSingleDisabledSavingVariant(string_key, string_key_variant)"
              />
              <p class="control">
                <b-button
                  :disabled="disabledSavingVariant[string_key_variant.id]"
                  class="button is-primary"
                  @click="saveTraslationVariant(string_key, string_key_variant)"
                >
                  <b-icon icon="content-save-outline" />
                </b-button>
              </p>
            </template>
            <template v-else>
              <b-button class="button is-primary" @click="addTranslation(string_key_variant)">
                <b-icon icon="plus" />
              </b-button>
            </template>
          </b-field>
          <hr :key="string_key.id + 'hr2'" />
        </template>
      </template>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />
  </section>
</template>

<script>
import materialTools from '@/helpers/mixins/materialTools'
import permissionMixin from '@/helpers/mixins/permissionMixin'

export default {
  name: 'Translationsmaterial',
  mixins: [permissionMixin, materialTools],
  data() {
    return {
      isLoading: false,
      tablematerial: {},
      id: undefined,
      dictionaries: {},
      selectedFromLanguage: '',
      selectedToLanguage: '',
      fromLanguage: {},
      disabledSaving: {},
      disabledSavingVariant: {},
      toLanguage: '',
      fromLanguages: [{ name: 'en' }, { name: 'it' }, { name: 'fr' }, { name: 'de' }, { name: 'dk' }],
      language: '',
      translations: {},
      selectedModule: 'tailored',
      selectedSection: '',
    }
  },
  watch: {
    selectedModule() {
      this.selectedSection = ''
    },
    selectedSection(section) {
      if (section) {
        this.loadSection(section)
      }
    },
    selectedToLanguage() {
      if (this.selectedSection) {
        this.calculateDisabledSaving()
      }
    },
  },
  mounted() {
    if (this.userInfo && this.userInfo.type === 'A') {
      this.language = this.$parent.loggedUser.language
      this.selectedFromLanguage = this.language
      this.selectedToLanguage = this.language
    } else {
      this.$router.push('/forbidden')
    }
  },
  methods: {
    loadSection(section) {
      const cloneDeep = require('clone-deep')
      this.isLoading = true
      this.getMaterialArray(section)
        .then(arrayresponse => {
          this.$set(this.tablematerial, section, cloneDeep(arrayresponse))
          this.calculateDisabledSaving()
          this.isLoading = false
        })
        .catch(() => {
          this.$set(this.tablematerial, section, [])
          this.isLoading = false
        })
    },
    addTranslation(material) {
      if (material.translations == undefined) {
        material.translations = {}
      }
      material.translations[this.selectedToLanguage] = null

      this.$forceUpdate()
    },
    calculateDisabledSaving() {
      let category = this.selectedSection
      for (let material in this.tablematerial[category]) {
        this.disabledSaving[this.tablematerial[category][material].id] = this.checkDisabledSaving(
          this.tablematerial[category][material]
        )

        for (let variant in this.tablematerial[category][material].variants) {
          this.disabledSavingVariant[
            this.tablematerial[category][material].variants[variant].id
          ] = this.checkDisabledSavingVariant(
            this.tablematerial[category][material],
            this.tablematerial[category][material].variants[variant]
          )
        }
      }
      this.$forceUpdate()
    },
    checkSingleDisabledSaving(material) {
      this.disabledSaving[material.id] = this.checkDisabledSaving(material)
      this.$forceUpdate()
    },
    checkSingleDisabledSavingVariant(material, variant) {
      this.disabledSavingVariant[variant.id] = this.checkDisabledSavingVariant(material, variant)
      this.$forceUpdate()
    },
    checkDisabledSavingVariant(material, variant) {
      if (variant.translations == undefined) {
        return true
      }
      if (
        variant.translations[this.selectedToLanguage] == null ||
        variant.translations[this.selectedToLanguage] == ''
      ) {
        return true
      }
      if (
        this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id) != undefined &&
        this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id).variants != undefined &&
        this.$updateavailableMaterials[this.selectedSection]
          .find(el => el.id == material.id)
          .variants.find(el2 => el2.id == variant.id) != undefined &&
        this.$updateavailableMaterials[this.selectedSection]
          .find(el => el.id == material.id)
          .variants.find(el2 => el2.id == variant.id).translations != undefined &&
        this.$updateavailableMaterials[this.selectedSection]
          .find(el => el.id == material.id)
          .variants.find(el2 => el2.id == variant.id).translations[this.selectedToLanguage] ==
          variant.translations[this.selectedToLanguage]
      ) {
        return true
      }
      return false
    },

    checkDisabledSaving(material) {
      if (material.translations == undefined) {
        return true
      }
      if (
        material.translations[this.selectedToLanguage] == null ||
        material.translations[this.selectedToLanguage] == ''
      ) {
        return true
      }
      if (
        this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id) != undefined &&
        this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id).translations !=
          undefined &&
        this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id).translations[
          this.selectedToLanguage
        ] == material.translations[this.selectedToLanguage]
      ) {
        return true
      }
      return false
    },
    saveTraslationVariant(material, variant) {
      this.isLoading = true
      let truematerial = this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id)
      let truevariant = truematerial.variants.find(el => el.id == variant.id)
      if (truevariant.translations == undefined) {
        truevariant.translations = {}
      }
      truevariant.translations[this.selectedToLanguage] = variant.translations[this.selectedToLanguage]
      this.disabledSavingVariant[variant.id] = true
      this.$db
        .collection(this.selectedSection)
        .doc(material.id)
        .update({ variants: truematerial.variants })
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    saveTraslation(material) {
      this.isLoading = true
      let truematerial = this.$updateavailableMaterials[this.selectedSection].find(el => el.id == material.id)
      if (truematerial.translations == undefined) {
        truematerial.translations = {}
      }
      truematerial.translations[this.selectedToLanguage] = material.translations[this.selectedToLanguage]
      this.$db
        .collection(this.selectedSection)
        .doc(material.id)
        .update({ translations: material.translations })
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
